import React, { useState } from "react";
import Slider from "react-slick";
import "./Carousel.css"; // Import your custom styles
import ImageViewer from "./ImageViewer";

interface Document {
  name: string;
  url: string;
}
interface CarouselProps {
  images: Document[];
}

const Carousel: React.FC<CarouselProps> = ({ images }) => {
  const [isViewerImageOpen, setViewerImage] = useState(false);

  const openViewerImage = () => {
    setViewerImage(true);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div>
      <Slider {...settings}>
        {images?.length > 0 &&
          images.map((image, index) => (
            <div key={index}>
              <img
                src={image.url}
                alt={image.name}
                className="justify-self-center flex w-80 h-48 sm:h-full object-contain cursor-pointer"
                onClick={() => openViewerImage()}
              />
            </div>
          ))}
      </Slider>
      {isViewerImageOpen && (
        <ImageViewer
          images={images}
          isViewerImageOpen={isViewerImageOpen}
          onClose={() => setViewerImage(false)}
        />
      )}
    </div>
  );
};

export default Carousel;
